import React from 'react';

const ContractPage = () => {
  return <div>ContractPage</div>;
};

export default ContractPage;
